import { useQuery, gql } from "@apollo/client";
import PublicareClientFragment from "../../auth/fragments/PublicareClientFragment";

export const OwnClientsQuery = gql`
  query OwnClients($filterEmptyCartClients: Boolean, $queryString: String) {
    me {
      _id
      clients(
        filterEmptyCartClients: $filterEmptyCartClients
        queryString: $queryString
      ) {
        ...PublicareClientFragment
      }
    }
  }
  ${PublicareClientFragment}
`;

const stableSort = (arr, compareFn, order) =>
  arr
    .map((item, index) => ({ item, index }))
    .sort((a, b) => compareFn(a.item, b.item) * order || a.index - b.index)
    .map(({ item }) => item);

const compareParams = (param) => (clientA, clientB) => {
  const valueA = clientA[param];
  const valueB = clientB[param];

  const cleanedA = typeof valueA === "string" ? valueA.toLowerCase() : valueA;
  const cleanedB = typeof valueB === "string" ? valueB.toLowerCase() : valueB;

  if (cleanedA > cleanedB) return -1;
  if (cleanedA < cleanedB) return 1;
  return 0;
};

const useOwnClients = ({
  queryString = "",
  sortField = null,
  filterEmptyCartClients = false,
} = {}) => {
  const { loading, error, data } = useQuery(OwnClientsQuery, {
    variables: {
      filterEmptyCartClients,
      queryString,
    },
  });

  const ownClients = data?.me?.clients || [];

  const privateClients = ownClients.filter(
    (client) => client.isPrivateCustomer,
  );

  const institutionClients = ownClients.filter(
    (client) => client.isInstitution,
  );
  const showEMSDepartment = institutionClients.some((i) => i.showEMSDepartment);

  let sortedPrivateClients: any = [];
  if (sortField) {
    const [field, order] = sortField.split("_");
    sortedPrivateClients = stableSort(
      privateClients,
      compareParams(field),
      order === "DESC" ? 1 : -1,
    );
  } else {
    sortedPrivateClients = privateClients;
  }

  return {
    loading,
    error,
    ownClients,
    showEMSDepartment,
    institutionClients,
    privateClients: sortedPrivateClients,
  };
};

export default useOwnClients;
